<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column show-overflow-tooltip prop="Login_Name" :label="$t('getapi[3255]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Employee_Name" :label="$t('getapi[3201]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Action_Flag" :label="$t('getapi[3256]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Module_Name" :label="$t('getapi[3257]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Login_Host_Name" :label="$t('getapi[3258]')" width="150">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Login_IP_Address" :label="$t('getapi[345]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Action_Time" :label="$t('getapi[3259]')" width="130">
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="LoginHistoryViewInfo" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'loginhistory',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: "", // 当前用户
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('loginhistory'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.authority()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1078]"),this.$t("getapi[12]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            },
            //修改页数
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('loginhistory',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'LoginHistoryViewInfo');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign,
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/User/SYS_Users/LoginHistoryDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
